<template>
  <div class="recycle-way-component">
    <div class="recycle-way-content">
      <div class="recycle-way box">
        <img class="icon-recycle-way" src="./img/icon_recycle_way_title.png" />
        <div class="recycle-way-list">
          <div
            v-for="(item, index) in recycleList"
            :key="index"
            class="recycle-way-item"
            :class="{
              over: item.id === overId
            }"
            @mouseover="pauseLoop(item)"
            @mouseout="restartLoop(item)"
          >
            <img class="icon-recycle-way" :src="item.id === selectRecycle.id ? item.selIcon : item.icon" />
          </div>
        </div>
        <div class="recycle-way-box">
          <el-carousel
            ref="carouselRef"
            :autoplay="false"
            indicator-position="none"
            height="530px"
            arrow="never"
            @change="carouselChange"
          >
            <el-carousel-item
              v-for="(item, index) in recycleList"
              :key="index"
            >
              <div
                class="recycle-way-image"
              >
                <img class="icon-recycle-way-bg" :src="item.contentIcon" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, CarouselItem } from 'element-ui';

let timer = null;

export default {
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  data () {
    return {
      num: 0,
      overId: '',
      recycleList: [
        {
          id: '1',
          index: 0,
          title: '邮寄回收',
          icon: require('./img/icon_sf_tab.png'),
          selIcon: require('./img/icon_sf_tab_sel.png'),
          contentIcon: require('./img/icon_sf_tab_content.png')
        },
        {
          id: '2',
          index: 1,
          title: '上门回收',
          icon: require('./img/icon_visit_tab.png'),
          selIcon: require('./img/icon_visit_tab_sel.png'),
          contentIcon: require('./img/icon_visit_tab_content.png')
        },
        {
          id: '3',
          index: 2,
          title: '到店回收',
          icon: require('./img/icon_store_tab.png'),
          selIcon: require('./img/icon_store_tab_sel.png'),
          contentIcon: require('./img/icon_store_tab_content.png')
        }
      ],
      selectRecycle: {}
    };
  },
  methods: {
    carouselChange (index) {
      if (index === this.selectRecycle.index) return;
      this.selectRecycle = this.recycleList[index];
      this.restartLoop(this.selectRecycle);
    },
    carouselHandler (interfaceName, params) {
      this.$refs.carouselRef && this.$refs.carouselRef[interfaceName](params);
    },
    startLoop () {
      this.overLoop();
      timer = setInterval(() => {
        this.selectRecycle = this.recycleList[this.num % this.recycleList.length];
        this.carouselHandler('setActiveItem', this.selectRecycle.index);
        this.num++;
      }, 5000);
    },
    pauseLoop (item) {
      this.overLoop();
      this.overId = item.id;
      if (this.selectRecycle.id !== item.id) {
        this.selectRecycle = item;
        this.carouselHandler('setActiveItem', this.selectRecycle.index);
      }
    },
    restartLoop (item) {
      this.overId = '';
      this.num = item.index + 1;
      this.startLoop();
    },
    overLoop () {
      clearInterval(timer);
    }
  },
  destroyed () {
    this.overLoop();
  },
  mounted () {
    this.num++;
    this.selectRecycle = this.recycleList[0];
    this.startLoop();
  }
};
</script>

<style scoped>
.recycle-way-content {
  padding: 100px 0 105px;
  height: 1024px;
  background: linear-gradient(180deg,#f7f7f7, #fbfbfb);
  border-radius: 260px 0 0 0;
  .recycle-way {
    text-align: center;
  }
  .icon-recycle-way {
    width: 322px;
    height: 64px;
  }
  .recycle-way-list {
    display: flex;
    justify-content: space-between;
    margin: 60px 0 18px;
    .recycle-way-item {
      cursor: pointer;
      transform: scale(1);
      transition: 0.3s;
      &.over {
        transform: scale(1.03);
      }
    }
    .icon-recycle-way {
      width: 375px;
      height: 150px;
    }
  }
  .recycle-way-box {
    position: relative;
    .recycle-way-image {
      width: 1200px;
      height: 530px;
    }
  }
  .icon-recycle-way-bg {
    width: 100%;
    height: 100%;
  }
}
.box {
  margin: 0 auto;
  width: 1200px;
}
.fade-leave-active {
  opacity: 0;
  transition: 0.5s ease .25s;
}
.fade-enter, .fade-enter-active {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/components/recycle-way.vue